import type { Iteration } from '@gonfalon/experiments/types';
import type { Variation } from '@gonfalon/flags/types';

export const transformTreatments = (
  treatments: NonNullable<Iteration['treatments']> = [],
  flagVariations?: Variation[],
): Array<{
  name: string;
  allocationPercent: string;
  baseline: boolean;
  parameters: Array<{ flagKey: string; variationId: string }>;
  imageFileId?: string;
  assignmentVariantId?: string;
}> =>
  treatments.map(
    ({
      parameters = [],
      name,
      allocationPercent,
      baseline,
      imageFileId,
      assignmentVariantId,
    }: {
      parameters?: Array<{ flagKey?: string; variationId?: string }>;
      name?: string;
      allocationPercent?: string;
      baseline?: boolean;
      imageFileId?: string;
      assignmentVariantId?: string;
    }) => {
      const isWarehouseAssignment = Boolean(assignmentVariantId);

      return {
        name: flagVariations?.find(({ _id }) => _id === (parameters?.[0]?.variationId ?? ''))?.name ?? name ?? '',
        allocationPercent: allocationPercent ?? '0',
        baseline: Boolean(baseline),
        parameters: isWarehouseAssignment
          ? []
          : (parameters ?? []).map(
              ({ flagKey = '', variationId = '' }: { flagKey?: string; variationId?: string }) => ({
                flagKey,
                variationId,
              }),
            ),
        imageFileId,
        ...(assignmentVariantId ? { assignmentVariantId } : {}),
      };
    },
  );
